module.exports = __webpack_public_path__ + "static/Esme-a3a86f20af68386b82cfae7d4e632616.svg";